module.exports = __webpack_public_path__ + "choose-image.db1937ca7f18c18df016811ab88e75cd.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/LogoEditor/choose-image.svg
// module id = 1612
// module chunks = 8